import * as React from 'react';
import { AuthContext } from 'contexts';
import { Link, Text, theme } from 'components';
import { formatPhoneNumber } from 'utils';
import type { TextProps } from 'components/Typography/Text';
import type { LinkProps } from 'components/Typography/Link';
import styled, { StyledComponent } from 'styled-components';
import { StyledSkeletonInput } from './commonStyled';

const StyledLink = styled(Link)`
  &&& {
    color: ${theme.black};
    &:hover {
      text-decoration: underline;
    }
  }
`;

export interface BranchCellProps {
  location?: string;
  address?: string;
  loading?: boolean;
  type: 'name' | 'phone';
}

const BranchCell: React.FC<BranchCellProps> = ({
  location,
  address,
  type,
  loading,
}) => {
  const { auth } = React.useContext(AuthContext);
  const locIndex = Number(location);
  const addIndex = Number(address);
  let Wrapper:
    | React.FC<TextProps>
    | StyledComponent<
        React.ForwardRefExoticComponent<
          LinkProps & React.RefAttributes<HTMLLinkElement>
        >,
        any,
        {},
        never
      > = Text;
  let content;
  if (!loading) {
    switch (type) {
      case 'name':
        content = auth?.org.locations[locIndex]?.name;
        break;
      case 'phone':
        content = formatPhoneNumber(
          auth?.org.addresses[locIndex]?.[addIndex]?.phone || '',
        );
        Wrapper = StyledLink;
        break;
      default:
        content = null;
    }
  }
  return loading ? (
    <StyledSkeletonInput size="small" />
  ) : (
    <Wrapper>{content}</Wrapper>
  );
};

export default React.memo(BranchCell);
